import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card shadow mb-4" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "float-end" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_6 = { class: "location-map" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParameterHelp = _resolveComponent("ParameterHelp")!
  const _component_LocationSearchControl = _resolveComponent("LocationSearchControl")!
  const _component_EstatesMap = _resolveComponent("EstatesMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('form.labels.location')) + " ", 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ParameterHelp, {
          estateType: _ctx.estateType,
          name: "location"
        }, null, 8, ["estateType"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createBlock(_component_LocationSearchControl, {
        class: "cursor-default",
        value: _ctx.value,
        onInput: _ctx.onInput,
        key: 'search' + _ctx.clearCounter
      }, null, 8, ["value", "onInput"])),
      (_ctx.invalid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('form.errors.locationNotFilled')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createBlock(_component_EstatesMap, {
          key: _ctx.value !== null ? _ctx.value.id : null,
          "main-estate": _ctx.selectedPlace
        }, null, 8, ["main-estate"]))
      ])
    ])
  ]))
}